import { PopupState } from './types';

export const defaultState: PopupState = {
  nextToastId: 1,
  toasts: []
};
